import {fulfilledState, pendingState, rejectedState, resError} from "@helpers";
import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import ScenariosService from "@services/ScenariosService";

export const getProducts = createAsyncThunk(
  "scenario/products",
  async (_, {rejectWithValue}) => {
    try {
      const response = await ScenariosService.getProducts();

      return response.data;
    } catch (err) {
      return rejectWithValue(resError(err));
    }
  },
);

export const getScenariosFeedbackTypes = createAsyncThunk(
  "scenario/types",
  async (_, {rejectWithValue}) => {
    try {
      const response = await ScenariosService.getScenariosFeedbackTypes();

      return response.data;
    } catch (err) {
      return rejectWithValue(resError(err));
    }
  },
);

export const getCertificationTypes = createAsyncThunk(
  "certification/types",
  async (_, {rejectWithValue}) => {
    try {
      const response = await ScenariosService.getCertificationTypes();

      return response.data;
    } catch (err) {
      return rejectWithValue(resError(err));
    }
  },
);

const initialState = {
  products: [],
  feedback_types: [],
  certification_types: [],
  errors: null,
  error: "",
  status: "",
};

const scenarioOptionsSlice = createSlice({
  name: "scenario-options",
  initialState,
  reducers: {
    setErrors(state, action) {
      state.errors = action.payload;
    },
    setError(state, action) {
      state.error = action.payload;
    },
    setStatus(state, action) {
      state.status = action.payload;
    },
    clearOptions() {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getProducts.pending, (state) => {
        pendingState(state);
      })
      .addCase(getProducts.fulfilled, (state, action) => {
        state.products = action.payload;
        fulfilledState(state);
      })
      .addCase(getProducts.rejected, (state, action) => {
        rejectedState(state, action);
      })

      .addCase(getScenariosFeedbackTypes.pending, (state) => {
        pendingState(state);
      })
      .addCase(getScenariosFeedbackTypes.fulfilled, (state, action) => {
        state.feedback_types = action.payload;
        fulfilledState(state);
      })
      .addCase(getScenariosFeedbackTypes.rejected, (state, action) => {
        rejectedState(state, action);
      })

      .addCase(getCertificationTypes.pending, (state) => {
        pendingState(state);
      })
      .addCase(getCertificationTypes.fulfilled, (state, action) => {
        state.certification_types = action.payload;
        fulfilledState(state);
      })
      .addCase(getCertificationTypes.rejected, (state, action) => {
        rejectedState(state, action);
      });
  },
});

export const {setError, setStatus, clearOptions} = scenarioOptionsSlice.actions;
export default scenarioOptionsSlice.reducer;
